export const WELCOME_SEEN_KEY = 'forja-welcome-seen';

export function markWelcomeSeen() {
  try { localStorage.setItem(WELCOME_SEEN_KEY, '1'); } catch {}
}

export function hasSeenWelcome(): boolean {
  try { return localStorage.getItem(WELCOME_SEEN_KEY) === '1'; } catch { return false; }
}